import sortStore from '../stores/sortStore';

export default class DataSortController {
  static handleSelectedSortCodeChange(sortCode: string) {
    sortStore.setSelectedSortCode(sortCode);
  }
}
